<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)">

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <br>
      <app-st-header-title [inputVal]="'Your Wishlist'"></app-st-header-title>
      <br>
      <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
        <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                              (click)="this.onCancel()"></app-st-button-cancel>
        <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                  (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
          [idVal]="'top-create-button-id'" [label]="'Create'" [primary]="true"
                       (click)="this.onCreateWishlistEntry()"></app-st-button>
      </div>
      <br>
      <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
        <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
        <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
          <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
        </div>
        <br>
      </div>
      <div *ngIf="showPageSuccessMessages" class="container st-form text-success" #goUp>
        <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
          <b>{{successMsg.field}}:</b> {{successMsg.detail}}
        </div>
        <br>
      </div>
      <br>
      <br>
      <app-st-pagination2 [idVal]="'wishlist-pagination-id'" [collectionSize]="this.collectionSize"
                          [currentPage]="this.page" [pageSize]="15" [maxPagesDisplayed]="9"
                          [customPageSizes]="this.customPageSizes"
                          (pageChange)="changePageResults($event)" #feedbackpaginator
      ></app-st-pagination2>
      <br>
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Title</th>
          <th scope="col">Type</th>
          <th scope="col">CreatedTS</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of rows">
          <td (click)="onViewDetails(row)">{{row['feedbackId']}}</td>
          <td (click)="onViewDetails(row)">{{row['feedbackTitleTxt']}} <i class="bi bi-search" (click)="onViewDetails(row)"></i></td>
          <td (click)="onViewDetails(row)">{{row['feedbackTypeDto']['feedbackTypeDisplayName']}}</td>
          <td (click)="onViewDetails(row)">{{row['createdTS']}}</td>
        </tr>
        </tbody>
      </table>
      <br>
      <app-st-button-back-to-top></app-st-button-back-to-top>
      <br>

      <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
        <app-st-button-cancel [idVal]="'bottom-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                              (click)="this.onCancel()"></app-st-button-cancel>
        <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                  (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
          [idVal]="'bottom-create-button-id'" [label]="'Create'" [primary]="true"
                       (click)="this.onCreateWishlistEntry()"></app-st-button>
      </div>
    </div>
  </div>
</div>
